import { render, staticRenderFns } from "./DetailReturMarketplace.vue?vue&type=template&id=4ef27c2b&"
import script from "./DetailReturMarketplace.vue?vue&type=script&lang=js&"
export * from "./DetailReturMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports